import React from 'react';
import {compareDesc, format} from "date-fns";
import { TailSpin } from 'react-loading-icons'
import InfoBubble from '../components/InfoBubble';
import infoTexts from '../components/infoTexts';

const SingleDetail = ({ nextStep, handleChange, values, apartment, isLoading, focusedTitleRef }) => {
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const CheckOpen = () => {

    }

    if(isLoading) {
        return (
            <section>
                <TailSpin stroke="#009cdd" fill="#009cdd" height="2rem" style={{"display": "block", "margin": "auto"}} />
                <div style={{"display": "block", "textAlign": "center", "marginTop": "8px"}}>
                    <p>Lade…</p>
                </div>
            </section>
        )
    } else if(apartment !== null) {
        return (
            <section className="row mb-5">
				<div className="col-12 col-md-4">
					<div className="article-categories">
						<a href="/wohnungssuche/" className="article-category">Wohnung finden</a>
					</div>
                    <h1><span>{apartment.title}</span></h1>

					{(() => {
						if(apartment.meta.registrationOpen === true) {
							if(apartment.meta.registrationEnds === null) {
								return(
									<div className="apartment-details-status">
										Die Anmeldung für die Auslosung ist möglich.
									</div>
								)
							} else if (compareDesc(Date.now(), new Date(apartment.meta.registrationEnds)) > 0) {
								return(
									<div className="apartment-details-status">
										Die Anmeldefrist für die Auslosung ist am {format(new Date(apartment.meta.registrationEnds), "dd.MM.yyyy")}, um {format(new Date(apartment.meta.registrationEnds), "HH:mm")} Uhr.
									</div>
								)
							}
						}

						return(
							<div className="apartment-details-status">
								Die Anmeldefrist für die Auslosung ist abgelaufen.
							</div>
						)
					})()}

				</div>
				<div className="col-12 col-md-8">
					{(() => {
						const image = apartment.meta.headerImage ?? apartment.meta.thumbnailId;
						return image ? (
							<img src={ image.node.mediaItemUrl } alt={ image.node.title } className="img-fluid"/>
						) : null;
					})()}
                    {/*<div className="img-overlay"></div>*/}
				</div>

				<div className="col-12 apartment-details">
					<div className="apartment-details-table">
						<h3>{ apartment.meta.apartmentType }</h3>
						<table>
							<tbody>
								<tr>
									<th>Wo:</th>
									<td>{ apartment.meta.address }, { apartment.meta.zip } { apartment.meta.city }</td>
								</tr>
								<tr>
									<th>Zimmer:</th>
									<td>{ apartment.meta.numberOfRooms }</td>
								</tr>
								<tr>
									<th>Etage:</th>
									<td>{ apartment.meta.floor }</td>
								</tr>
								<tr>
									<th>Fläche:</th>
									<td>{ apartment.meta.surfaceArea } m<sup>2</sup></td>
								</tr>
								<tr>
									<th>Miete:</th>
									<td>{ apartment.meta.rentPerMonth }.- inkl. Nebenkosten</td>
								</tr>
								<tr>
									<th>Verfügbar ab:</th>
									<td>{ apartment.meta.availableByAgreement ? 'Frei nach Vereinbarung' : format(new Date(apartment.meta.availabilityDate), "dd.MM.yyyy") }</td>
								</tr>
								<tr>
									<th>Anteilscheinkapital
										<InfoBubble label="Anteilscheinkapital" text={ infoTexts.anteilscheinkapital } />
										:
									</th>
									<td>{ apartment.meta.anteilscheinkapital }.-</td>
								</tr>
								<tr>
									<th>Mindestbelegung
										<InfoBubble label="Mindestbelegung" text={ infoTexts.mindestbelegung } />
										:
									</th>
									<td>
										{ apartment.meta.minResidents + ((apartment.meta.minResidents == 1) ? ' Person' : ' Personen') }
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div className="mt-5 apartment-details-list">
						<h3>Was zeichnet die Wohnung aus?</h3>
						<div className="custom-list-items" dangerouslySetInnerHTML={{ __html: apartment.meta.flatHighlights }} />
					</div>

					<div className="mt-5 apartment-details-info">
						<h3>Passt die Wohnung zu mir?</h3>
						<div dangerouslySetInnerHTML={{ __html: apartment.meta.flatFit }} />
					</div>

					{(() => {
						if(apartment.meta.settlementLink !== null) {
							return(
								<div className="apartment-details-button-to-settlement">
									<a href={ apartment.meta.settlementLink } target="_blank">Mehr über die Siedlung erfahren</a>
								</div>
							)
						}
					})()}

					<div className="apartment-details-files">
						{
							apartment.meta.files !== null ?
								apartment.meta.files.map((file, index) => {
									return (
										<div key={file.file.id || index}>
											<a download={ file.file.node.title } target="_blank"
											   href={ file.file.node.mediaItemUrl }>
												{ file.label }
												{/*<i className="download-icon"*/}
												{/*   style={{backgroundImage: "url('/wp-content/themes/bones/assets/img/downloadicon.svg')"}}></i>*/}
											</a>
										</div>
									)
								}) : ''
						}
					</div>
				</div>

				{(() => {
					if(apartment.meta.registrationOpen === true) {
						if(apartment.meta.registrationEnds === null || compareDesc(Date.now(), new Date(apartment.meta.registrationEnds)) > 0) {
							return (
								<div className="col-12">
									<button className="mt-5 btn btn-secondary sign-up-button" onClick={Continue}>Ich interessiere mich für diese Wohnung</button>
								</div>
							)
						}
					}
				})()}
            </section>
        )
    } else {
        return (
            <section className="mb-5">
				<h1><span>Diese Wohnung ist nicht mehr verfügbar</span></h1>
				<a className="btn btn-secondary" href="/wohnungen">ZU DEN AKTUELLEN WOHNUNGEN</a>
            </section>
        )
    }
}

export default SingleDetail
